// app/javascript/landing/components/SmartImage.tsx
import React, { useEffect, useState } from "react";
import clsx from "clsx";

type SmartImageProps = {
  src: string;
  alt?: string;
  className?: string;
  wrapperClassName?: string;
  fill?: boolean;
  width?: number;
  height?: number;
};

export function SmartImage({
  src,
  alt = "",
  className,
  wrapperClassName,
  fill = false,
  width,
  height,
}: SmartImageProps) {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = src;

    if (width && height) {
      // si el dev entrega width/height, ya reservamos espacio
    }

    if (img.complete) {
      setLoaded(true); // cacheado → sin fade
    } else {
      img.onload = () => setLoaded(true);
    }
  }, [src, width, height]);

  return (
    <div
      className={clsx("relative overflow-hidden", wrapperClassName)}
      // style={
      //   width && height && !fill
      //     ? { aspectRatio: `${width} / ${height}` }
      //     : undefined
      // }
    >
      <img
        src={src}
        alt={alt}
        width={width}
        height={height}
        draggable={false}
        className={clsx(
          fill
            ? "absolute inset-0 w-full h-full object-cover"
            : "block w-full h-auto",
          "transition-opacity duration-700",
          loaded ? "opacity-100" : "opacity-0",
          className
        )}
      />
    </div>
  );
}
